var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -2319.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Camera",
    transform: "translate(445.000000, 2319.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,4 L11,7 L28,7 C30.146,7.145 31.854,8.854 32,11 L32,11 L32,28 L4,28 C1.854,27.854 0.145,26.146 0,24 L0,24 L0,7 L2,7 L4,4 L9,4 Z M16,12 C12.687,12 10,14.687 10,18 C10,21.313 12.687,24 16,24 C17.592,24 19.117,23.368 20.242,22.242 C21.368,21.117 22,19.592 22,18 C22,14.687 19.313,12 16,12 Z M16,15 C17.657,15 19,16.343 19,18 C19,19.657 17.657,21 16,21 C14.343,21 13,19.657 13,18 C13,16.343 14.343,15 16,15 Z M27.5,10 C26.672,10 26,10.671 26,11.5 C26,12.329 26.672,13 27.5,13 C28.328,13 29,12.329 29,11.5 C29,10.671 28.328,10 27.5,10 Z",
    id: 175
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionCamera);
export default __webpack_public_path__ + "static/media/navigation-and-action-camera.99499f14.svg";
export { ForwardRef as ReactComponent };